<ng-container *cngActionUnresult="responseModels && responseModels.length > 0; label: 'agent:panel.knowledge_base.no_result'">
  <div class="container">
    <span *ngIf="responseModels.length === 0">
      {{ 'agent:panel.knowledge_base.no_result' | translate }}
    </span>
    <knowledge-base-response-models-accordion
      *ngIf="responseModels.length"
      [responseModels]="responseModels"
      [canCopyPaste]="canCopyPaste"
      [expanded]="false"
      [multi]="false"
    >
    </knowledge-base-response-models-accordion>
  </div>
</ng-container>
<div class="cng-loader" *ngIf="loading"><div class="loader"></div></div>
